import myDialogPc from './myDialogPc.vue'
const my_dialogPc = {
    install: function (Vue) {
        Vue.component('my_dialogPc', myDialogPc)
    }
};
// 导出组件
export default my_dialogPc